import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfirmActionComponent } from 'src/app/app-layout/modal-confirm-action/modal-confirm-action.component';
import { DropdownData } from 'src/app/models/dropdownData';
import { SortObject } from 'src/app/models/sortObject';
import { ProfileDropdownsService } from 'src/app/services/profile-dropdowns';
import { ExtraFieldCounterService } from 'src/app/services/shared/extraFieldCounter';
import { ToastService } from 'src/app/services/toast.service';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { clearErrors } from 'src/app/utils/clearFormErrors';
import { fileSizeCalculator } from 'src/app/utils/fileSizeCalculator';
import { fileSizeValidator } from 'src/app/utils/fileSizeValidator';
import { toggleModalBlanket } from 'src/app/utils/toggleBlanket';
import { ModalActionableComponent } from '../modal-actionable/modal-actionable.component';
import { HttpEventType } from '@angular/common/http';
import { LoadingService } from 'src/app/services/shared/loading.service';

@Component({
  selector: 'apc-basic-crud-modal',
  templateUrl: './basic-crud-modal.component.html',
  styleUrls: ['./basic-crud-modal.component.scss'],
})
export class BasicCrudModalComponent {
  public data: DropdownData[];
  public typesDropdown: any;
  public hideDialog: boolean = false;
  public forms = new UntypedFormArray([]);
  public newForm: UntypedFormGroup;
  public editNewForm: boolean = false;
  public submitFailed = false;
  public isSaveFormOpen: boolean = false;
  @Input() public pertinence: string;
  @Input() public section: string;
  @Input() public subsection: string;
  @Input() public subtype: string;
  @Input() public type: string;
  @Input() public isField: boolean = false;
  @Input() personaSubsectionIdentifier: string;
  @Input() personaIdentifier: string;
  @Input() public icon: string;
  @Input() public iconEditeSel: string |null = null;
  @Input() isAddress: boolean = false;
  @Input() readDisable = true;
  @Input() elemsSort: SortObject[] = [
    {
      prop: 'code',
      dir: 'asc',
    },
  ];
  @Input() hiddenTitle: boolean= false;
  @Input() updateSelect: boolean= false;
  @Input() selectField:any;
  @Input() setSelect:any | null = null;
  @Output() valueSelected = new EventEmitter<any>(false);
  @Input() fieldSelected: any;
  
  @ViewChild(ModalActionableComponent) modalComponent: ModalActionableComponent;

  public showCodeValueForm: boolean;
  public showManager: boolean;
  public showOfficeForm: boolean;
  public showExtraTypesForm: boolean;
  public showExtraFieldNoteForm: boolean;
  public showExtraFieldLinkForm: boolean;
  public showExtraFieldFileForm: boolean;
  public extraFieldFileFormEdit: string;
  public showExtraFieldCustomFieldForm: boolean;
  public showOperationsSolutionForm: boolean;
  public showCertificationTypeForm: boolean;
  public showAccountTypeForm: boolean;
  public showIdentificationTypeForm: boolean;
  public showEquipmentSimcardForm: boolean;
  public showEquipmentFuelcardForm: boolean;
  public showEquipmentComputerForm: boolean;
  public showEquipmentTelepassForm: boolean;
  public showEquipmentCompanycarForm: boolean;
  public blanketIsActive: boolean = false;

  public fileFormData = new FormData();
  public permissionCreate: Object = '';
  public noValueTitle: string = '(no value)';
  public rowTitle: string = '';
  public managers = [];
  public fileRequired: boolean = false;
  public titleModal: string | null = null;
  constructor(
    private toastService: ToastService,
    private profileDropdownsService: ProfileDropdownsService,
    private translateService: TranslateService,
    private extraFieldCounter: ExtraFieldCounterService,
    private modalService: NgbModal,
    public loadingService: LoadingService
  ) {
    this.noValueTitle = this.translateService.instant('administration.sectionsManagement.profile.noValue');
  }

  ngOnInit(){
    this.titleModal = this.type? this.type == "crmsku"? "CRM SKU": 
    this.type == "costtype"? "Cost Type": 
    this.type == "costcenter"? "Cost Center":
    this.type == "l2"? "Area":
    this.type == "l3"? "Team": 
    this.type.charAt(0).toUpperCase() + this.type.slice(1) :null;

  }

  async initData() {
    /* pick form to render */
    this.showOfficeForm = this.isAddress;
    this.showExtraTypesForm = this.subtype === 'extras' && !this.isField;
    this.showExtraFieldNoteForm = this.isField && this.type === 'note';
    this.showExtraFieldLinkForm = this.isField && this.type === 'link';
    this.showExtraFieldFileForm = this.isField && this.type === 'file';
    this.showExtraFieldCustomFieldForm = this.isField && this.type === 'customfield';
    this.showOperationsSolutionForm =
      this.type === 'solution' && this.section === 'operations' && this.subsection === 'organizationchart';
    this.showCertificationTypeForm =
      this.type === 'type' && this.section === 'certification' && this.subsection === 'achievement';
    this.showAccountTypeForm =
      this.type === 'application' && this.section === 'account' && this.subsection === 'general';
    ////////////
    this.showIdentificationTypeForm =
      this.type === 'type' && this.section === 'identification' && this.subsection === 'general';
    ///////////
    this.showEquipmentSimcardForm =
      this.type === 'value' && this.section === 'equipment' && this.subsection === 'simcard';
    this.showEquipmentFuelcardForm =
      this.type === 'value' && this.section === 'equipment' && this.subsection === 'fuelcard';
    this.showEquipmentComputerForm =
      this.type === 'value' && this.section === 'equipment' && this.subsection === 'computer';
    this.showEquipmentTelepassForm =
      this.type === 'value' && this.section === 'equipment' && this.subsection === 'telepass';
    this.showEquipmentCompanycarForm =
      this.type === 'value' && this.section === 'equipment' && this.subsection === 'companycar';

    this.showCodeValueForm =
      !this.showExtraTypesForm &&
      !this.showOfficeForm &&
      !this.isField &&
      !this.showOperationsSolutionForm &&
      !this.showCertificationTypeForm &&
      !this.showAccountTypeForm &&
      !this.showIdentificationTypeForm &&
      !this.showEquipmentCompanycarForm &&
      !this.showEquipmentComputerForm &&
      !this.showEquipmentFuelcardForm &&
      !this.showEquipmentSimcardForm &&
      !this.showEquipmentTelepassForm;

    if (this.showCodeValueForm) {
      this.showManager =
        this.subsection === 'company' && (this.type === 'l1' || this.type == 'l2' || this.type == 'l3');
    }
    if (this.showManager) {
      this.managers = await this.profileDropdownsService.getAllManagers(
        this.section,
        this.subsection,
        this.type
      );
    }
    if (this.showOperationsSolutionForm) {
      this.managers = await this.profileDropdownsService.getAllResponsiblePersons(
        'operations',
        'organizationchart',
        'solution'
      );
    }
    if (this.isField) {
      let type = this.type;
      this.permissionCreate = {
        pertinence: this.pertinence,
        section: this.section,
        subsection: this.subsection,
        context: type,
        type: 'EDITOR',
      };
      this.typesDropdown = [];
      this.typesDropdown = await this.profileDropdownsService.getDropdownValues(
        this.section,
        this.subsection,
        this.subtype,
        this.type,
        false,
        this.personaSubsectionIdentifier,
        this.personaIdentifier,
        this.elemsSort
      );
    } else {
      let subsection = this.subsection;
      this.permissionCreate = {
        pertinence: this.pertinence,
        section: this.section,
        subsection: subsection,
        context: 'metadata',
        type: 'EDITOR',
      };
    }
    /* pick form to render end */
    this.data = [];
    this.forms = new UntypedFormArray([]);
    this.data = await this.profileDropdownsService.getDropdownValues(
      this.section,
      this.subsection,
      this.subtype,
      this.type,
      this.isField,
      this.personaSubsectionIdentifier,
      this.personaIdentifier,
      this.elemsSort
    );

    this.readDisable = true;

    // if data exists generate all forms
    if (this.data.length > 0) {
      this.data.forEach((el) => {
        this.forms.push(this.initForm(el));
      });
      // if not generate one empty form and put in edit mode
    } else {
      this.forms.push(this.initForm());
      let form: any = this.forms.controls[0];
      form.editForm = true;
      form.isCollapsed = true;
      setTimeout(() => toggleModalBlanket(`${this.section}-${this.subsection}-modal-row-0`));
    }
    // on init we want all dropdowns to be closed
    this.toggleAll();
  }

  initForm(data?) {
    let form = new UntypedFormGroup({});
    // basic name value form
    if (this.showCodeValueForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      if (this.section === 'operations' && this.type == 'crmsku') {
        form.addControl('code', new UntypedFormControl(data ? data.code : null, [Validators.required]));
      } else {
        form.addControl('code', new UntypedFormControl(data ? data.code : null));
        if(this.section === 'operations' && this.subsection == "kpi")
          form.addControl('groupType', new UntypedFormControl(data ? data.groupType : null));
      }
      // some basic forms have responsible persons
      if (this.showManager) {
        form.addControl('managerIdentifier', new UntypedFormControl(data ? data.managerIdentifier : null));
      }
    }
    // operational office form
    if (this.showOfficeForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('street', new UntypedFormControl(data ? data.street : null));
      form.addControl('houseNumber', new UntypedFormControl(data ? data.houseNumber : null));
      form.addControl('zip', new UntypedFormControl(data ? data.zip : null));
      form.addControl('city', new UntypedFormControl(data ? data.city : null));
      form.addControl('province', new UntypedFormControl(data ? data.province : null));
      form.addControl('phone', new UntypedFormControl(data ? data.phone : null));
    }

    // operations solution form
    if (this.showOperationsSolutionForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('lob', new UntypedFormControl(data ? data.lob : null));
      form.addControl('pillar', new UntypedFormControl(data ? data.pillar : null));
    }

    if (this.showCertificationTypeForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('vendor', new UntypedFormControl(data ? data.vendor : null, [Validators.required]));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('urlDescription', new UntypedFormControl(data ? data.urlDescription : null));
      form.addControl('urlBadge', new UntypedFormControl(data ? data.urlBadge : null));
      form.addControl('type', new UntypedFormControl(data ? data.type : null));
      form.addControl('subtype', new UntypedFormControl(data ? data.subtype : null));
      form.addControl('defaultExpiration', new UntypedFormControl(data ? data.defaultExpiration : null));
    }

    if (this.showAccountTypeForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('applicationUrl', new UntypedFormControl(data ? data.applicationUrl : null, [Validators.required]));
    }

    /* identification section */
    if (this.showIdentificationTypeForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('description', new UntypedFormControl(data ? data.description : null));
    }

    /* equipment section */
    if (this.showEquipmentSimcardForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('provider', new UntypedFormControl(data ? data.provider : null));
      form.addControl('puk', new UntypedFormControl(data ? data.puk : null));
      form.addControl('phoneNumber', new UntypedFormControl(data ? data.phoneNumber : null));
      form.addControl('plan', new UntypedFormControl(data ? data.plan : null));
    }

    if (this.showEquipmentFuelcardForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('provider', new UntypedFormControl(data ? data.provider : null));
      form.addControl('pin', new UntypedFormControl(data ? data.pin : null));
      form.addControl('dateExpiration', new UntypedFormControl(data ? data.dateExpiration : null));
    }

    if (this.showEquipmentComputerForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('brand', new UntypedFormControl(data ? data.brand : null));
      form.addControl('modelName', new UntypedFormControl(data ? data.modelName : null));
      form.addControl('modelNumber', new UntypedFormControl(data ? data.modelNumber : null));
      form.addControl('productNumber', new UntypedFormControl(data ? data.productNumber : null));
    }

    if (this.showEquipmentTelepassForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('viacardNumber', new UntypedFormControl(data ? data.viacardNumber : null));
    }

    if (this.showEquipmentCompanycarForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('model', new UntypedFormControl(data ? data.model : null));
      form.addControl('brand', new UntypedFormControl(data ? data.brand : null));
      form.addControl('rentalCompany', new UntypedFormControl(data ? data.rentalCompany : null));
      form.addControl('dateExpiration', new UntypedFormControl(data ? data.dateExpiration : null));
    }
    /* equipment section end */

    // extra types form
    if (this.showExtraTypesForm) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      form.addControl('name', new UntypedFormControl(data ? data.name : null, [Validators.required]));
      form.addControl('code', new UntypedFormControl(data ? data.code : null));
      form.addControl('description', new UntypedFormControl(data ? data.description : null));
      form.addControl('restrictionMode', new UntypedFormControl(data ? data.restrictionMode : null, [Validators.required]));
      if (this.type == 'customfield') {
        form.addControl('customFieldType', new UntypedFormControl(data ? data.customFieldType : null, [Validators.required]));
      }
    }

    if (this.isField) {
      form.addControl('identifier', new UntypedFormControl(data ? data.identifier : null));
      if (
        this.showExtraFieldCustomFieldForm &&
        data &&
        data.extraTypeCode &&
        data.extraTypeCode === 'CUSTOM_FIELD_BOOLEAN'
      ) {
        form.addControl('value', new UntypedFormControl(data ? data.value === 'true' : null, [Validators.required]));
      } else {
        form.addControl('value', new UntypedFormControl(data ? data.value : null, [Validators.required]));
      }
      form.addControl(
        'extraTypeIdentifier',
        new UntypedFormControl(data ? data.extraTypeIdentifier : null, [Validators.required])
      );
      form.addControl('dateStart', new UntypedFormControl(data ? data.dateStart : null));
      form.addControl('dateEnd', new UntypedFormControl(data ? data.dateEnd : null));
      form.addControl('notifyWhenExpired', new UntypedFormControl(data ? data.notifyWhenExpired : false));

      if (this.showExtraFieldFileForm) {
        form.removeControl('value');
        form.addControl('value', new UntypedFormControl(data ? data.value : null));
        form.addControl('fileName', new UntypedFormControl(data ? data.fileName : null));
        form.addControl(
          'fileSize',
          new UntypedFormControl(data ? fileSizeCalculator(data.fileSize) : null, [fileSizeValidator])
        );
        form.addControl('description', new UntypedFormControl(data ? data.description : null));
      }
      if (this.showExtraFieldLinkForm) {
        form.addControl('linkName', new UntypedFormControl(data ? data.linkName : null));
        form.addControl('description', new UntypedFormControl(data ? data.description : null));
      }
      if (this.showExtraFieldCustomFieldForm) {
        form.addControl('description', new UntypedFormControl(data ? data.description : null));
        form.addControl('extraTypeCode', new UntypedFormControl(data ? data.extraTypeCode : null));
      }
    }

    return form;
  }

  async saveForm(form: any) {
    if (form.valid || this.submitFailed) {
      this.submitFailed = false;
      // if id exists it means we are editing
      if (this.showExtraFieldFileForm || this.showCertificationTypeForm) {
        this.extraFieldFileFormEdit = form.value.identifier;
        if (!this.extraFieldFileFormEdit && !this.showCertificationTypeForm) {
          this.fileRequired = !form.value.fileSize;
          if (this.fileRequired) {
            return;
          }
        }
        this.fileFormData.delete('request');
        this.fileFormData.append('request', JSON.stringify(form.value));
        form.value = this.fileFormData;
      }
      let formToSave = JSON.parse(JSON.stringify(form.value));
      if (this.type === 'customfield' && this.isField) {
        if (form.controls.value.value !== null && typeof form.controls.value.value === 'boolean') {
          formToSave.value = form.controls.value.value.toString();
        }
        delete form.value.extraTypeCode;
      }
      if (
        formToSave.identifier &&
        !(this.showExtraFieldFileForm && this.extraFieldFileFormEdit && this.showCertificationTypeForm)
      ) {
        this.profileDropdownsService
          .updateValue(
            this.section,
            this.subsection,
            this.subtype,
            this.type,
            this.isField,
            formToSave,
            this.personaSubsectionIdentifier,
            this.personaIdentifier,
            this.extraFieldFileFormEdit
          )
          .then((result) => {
            form.editForm = false;
            this.blanketIsActive = false;
            form.markAsUntouched();
            this.toastService.showSuccess('Operation success!');
            if(this.updateSelect){
              if(this.type && this.setSelect && this.valueSelected){
                if(this.fieldSelected.identifier === result.identifier){
                  this.valueSelected.emit(result);
                }       
                this.setSelect();
              }
            }
            toggleModalBlanket(
              `${this.section}-${this.subsection}-modal-row-${this.forms.controls.findIndex((control) => control == form)}`
            );
            if (this.isField) {
              this.extraFieldCounter.fetchRefreshExtras(this.section);
            }
            form.markAsPristine();
            form.markAsUntouched();
          })
          .catch((e) => {
            clearErrors(form);
            this.submitFailed = true;
            this.toastService.showError('Operation error!');
            if (e.validationErrors.length > 0) {
              form.markAsPristine();
              checkForValidationErrors(e, form);
            }
          });
      }
      // creating new
      else {
        this.profileDropdownsService
          .createValue(
            this.section,
            this.subsection,
            this.subtype,
            this.type,
            this.isField,
            form.value,
            this.personaSubsectionIdentifier,
            this.personaIdentifier
          )
          .subscribe(
            (response: any) => {
              /* check if file upload to show progress */
              let isBadgeUpload =
                this.section == 'certification' &&
                this.subsection == 'achievement' &&
                this.subtype == 'lov' &&
                this.type == 'type';
              if ((this.type == 'file' && this.isField) || isBadgeUpload) {
                let loadingNum = Math.round((response.loaded / response.total) * 100);
                if (loadingNum > 0 && loadingNum < 101) {
                  this.loadingService.loadingProgress = loadingNum;
                }
              }
              /* check if file upload to show progress end */
              if (response.type === HttpEventType.Response) {
                var newItem = response.body;
                this.loadingService.fileLoading = false;
                this.loadingService.loadingProgress = 0;
                let newForm = this.initForm(newItem);
                if (!this.extraFieldFileFormEdit && !this.showCertificationTypeForm) {
                  this.forms.controls[this.forms.controls.length - 1] = newForm;
                } else {
                  this.forms.controls[this.forms.controls.findIndex((control) => control == form)] = newForm;
                }
                form.editForm = false;
                this.blanketIsActive = false;
                form.markAsUntouched();
                this.toastService.showSuccess('Operation success!');
                // case where we use CREATE to update file value
                if (!this.extraFieldFileFormEdit && !this.showCertificationTypeForm) {
                  toggleModalBlanket(`${this.section}-${this.subsection}-modal-row-${this.forms.controls.length - 1}`);
                } else {
                  toggleModalBlanket(
                    `${this.section}-${this.subsection}-modal-row-${this.forms.controls.findIndex((control) => control == form)}`
                  );
                }
                if (this.isField) {
                  this.extraFieldCounter.fetchRefreshExtras(this.section);
                }
              }
            },
            (e) => {
              clearErrors(form);
              this.submitFailed = true;
              this.toastService.showError('Operation error!');
              if (e.validationErrors.length > 0) {
                form.markAsPristine();
                checkForValidationErrors(e, form);
              }
            }
          );
      }
    } else {
      this.toastService.showError('Operation error!');
      form.markAsPristine();
      form.markAllAsTouched();
    }
  }

  async cancelForm(item) {
    if (item?.dirty) {
      const modalRef = this.modalService.open(ModalConfirmActionComponent, {
        backdropClass: 'modal-basic-crud-confirm',
      });
      modalRef.componentInstance.message = 'modals.message.undoChangesMessage';
      modalRef.result.then((result) => {
        if (result) {
          item.editForm = false;
          this.confirmCancelForm(item);
        } else {
          item.editForm = true;
        }
      });
    } else {
      this.forms.controls = this.forms.controls.filter(
        (el) => el.value.identifier !== null && el.value.identifier !== undefined
      );
      this.editFormEvent(item, false);
      if (this.forms.controls.length === 0) {
        this.modalComponent.close();
      }
    }
  }

  async confirmCancelForm(item) {
    // if canceling form that exists (edit form), fetch old form data and replace that data with current data that we want to cancel
    if (item.value.identifier) {
      const index = this.forms.controls.findIndex((p) => p.value.identifier === item.value.identifier);
      this.data = await this.profileDropdownsService.getDropdownValues(
        this.section,
        this.subsection,
        this.subtype,
        this.type,
        this.isField,
        this.personaSubsectionIdentifier,
        this.personaIdentifier,
        this.elemsSort
      );
      let oldData = this.data.find((h) => h.identifier == item.value.identifier);
      let form = this.initForm(oldData);
      this.forms.controls[index] = form;
    }
    // if canceling form that does not exist (new form), just remove it from the list
    else {
      this.forms.controls = this.forms.controls.filter(
        (el) => el.value.identifier !== null && el.value.identifier !== undefined
      );
      if (this.forms.controls.length === 0) {
        this.modalComponent.close();
      }
    }
    if (this.showExtraFieldFileForm) {
      this.fileRequired = false;
    }
    this.editFormEvent(item, false);
  }

  async deleteItem(form: any) {
    try {
      await this.profileDropdownsService.removeValue(
        this.section,
        this.subsection,
        this.subtype,
        this.type,
        this.isField,
        form.value.identifier,
        this.personaSubsectionIdentifier,
        this.personaIdentifier
      );
      this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== form.value.identifier);
      if (this.isField) {
        this.extraFieldCounter.fetchRefreshExtras(this.section);
      }
      this.toastService.showSuccess('Operation success!');
    } catch {
      this.toastService.showError('Operation error!');
    }
    if (this.forms.controls.length === 0) {
      this.modalComponent.close();
    }
  }

  toggleAll() {
    this.forms.controls.forEach((item: any) => {
      item.isCollapsed = !item.isCollapsed;
    });
  }

  editFormEvent(item, event) {
    const toggleElement = `${this.section}-${this.subsection}-modal-row-${this.forms.controls.findIndex((control) => control == item)}`;
    toggleModalBlanket(toggleElement);
    setTimeout(() => {
      document.getElementById(toggleElement) && document.getElementById(toggleElement).scrollIntoView({ behavior: 'smooth' });
    }, 100);
    item.editForm = event;
    this.blanketIsActive = event;
  }

  addNewForm() {
    // going to check if we already have some epty form
    let emptyAlreadyExists = false;
    this.forms.controls.forEach((item) => {
      if (!item.value.identifier) {
        emptyAlreadyExists = true;
      }
    });
    // add new form only if we dont have any empty form initialized
    if (!emptyAlreadyExists) {
      this.forms.push(this.initForm());
      this.forms.controls.forEach((formControl: any) => {
        // if the form is new/being created, put it to edit mode
        if (!formControl.value.identifier) {
          formControl.editForm = true;
        }
      });
      let newSectionId = `${this.section}-${this.subsection}-modal-row-${this.forms.controls.length - 1}`;
      setTimeout(() => toggleModalBlanket(newSectionId));
      setTimeout(() => {

        document.getElementById(newSectionId).scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }

  async download(item) {
    this.profileDropdownsService.downloadFile(
      this.section,
      this.subsection,
      this.subtype,
      item.value.identifier,
      this.personaSubsectionIdentifier,
      this.personaIdentifier
    );
  }

  generateRowTitle(item, isField, type) {
    var title = '';
    if (this.showCertificationTypeForm) {
      if (!item.value.vendor || !item.value.name) {
        return '';
      }
      return item.value.vendor + ' - ' + item.value.name;
    }
    if (item.value.identifier) {
      let itemValue = '';
      if (item.value.value !== null && typeof item.value.value === 'boolean') {
        itemValue = item.value.value.toString();
      } else {
        itemValue = item.value.value;
      }
      title = isField ? (type == 'file' ? item.value.fileName : itemValue) : item.value.name;
      if (isField) {
        let type = this.typesDropdown.find((el) => el.identifier === item.value.extraTypeIdentifier);
        let typeName = type ? type.name : '';
        let cutTitle = title ? title : '';
        if (cutTitle.length > 45) {
          cutTitle = cutTitle.substring(0, 45) + '...';
        }
        return cutTitle + ' [ ' + typeName + ' ]';
      } else {
        return title;
      }
    }
  }

  toggleElement(elemId) {
    this.forms.controls.forEach((item: any) => {
      if (item.value.identifier === elemId) {
        item.isCollapsed = !item.isCollapsed;
      } else {
        item.isCollapsed = true;
      }
    });
  }

  changeReadDisable(value: boolean) {
    this.readDisable = value;
  }


  getIsCollapsedValue(item:any){
    if(typeof item.isCollapsed != typeof undefined){
      return item.isCollapsed;
    }
    return false;
  }

  getEditFormValue(item:any){
    if(typeof item.editForm != typeof undefined){
      return item.editForm;
    }
    return false;
  }


}
